<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"545px"'
    :cpntTitulo='cpntTitulo'

    :cpntOnFecharDialog='reenviarNotaFechar'>
    <template slot='conteudo' v-if="Object.keys(formulario).length >= 1 && Object.keys(formulario.field).length >= 1">
      <div class="df-reenviar-nota-campos">
        <RF-Componente v-if="Object.keys(formulario.field.campo).length >= 1"
          :data-time='time'
          :cpntTamanho='formulario.field.campo.tamanho'
          :cpntModelo='formulario.field.campo.tipo'
          :cpntType='formulario.field.campo.type'
          :cpntStatus='formulario.field.campo.status'
          :cpntId='formulario.field.campo.id'
          :cpntClassDivField='formulario.field.campo.classDivField'
          :cpntNome='formulario.field.campo.nome'
          :cpntValue='formulario.field.campo.value'
          :cpntValueRef='formulario.field.campo.valueRef'
          :cpntOptions='formulario.field.campo.options'
          :cpntKeyValue='formulario.field.campo.keyValue'
          :cpntKeyMostra='formulario.field.campo.keyMostra'
          :cpntAutoComplete='formulario.field.campo.autocomplete'
          :cpntDisabled='formulario.field.campo.disabled'
          :cpntMostrar='formulario.field.campo.mostrar'
          :cpntMensagem='formulario.field.campo.mensagem'
          :cpntSelecioneNome='formulario.field.campo.selecioneNome'
          :cpntSelecioneValue='formulario.field.campo.selecioneValue'
          :cpntMensagemTipo='formulario.field.campo.mensagemTipo'
          :cpntAdicinarOption='formulario.field.campo.adicinarOption'
          :cpntMultiple='formulario.field.campo.multiple'
          :cpntAllRegistro='formulario.field.campo.allRegistro'
          :cpntExplica='formulario.field.campo.explica'
          :cpntConfig='formulario.field.campo.config'
          :cpntTabIndex='formulario.field.campo.tabIndex'
          :cpntMaxLength='formulario.field.campo.maxLength'
          :cpntOptionInicialNome='formulario.field.campo.optionInicialNome'
          :cpntOptionInicialValue='formulario.field.campo.optionInicialValue'

          :cpntOnChange='formulario.field.campo.onChange'
          :cpntOnBlur='formulario.field.campo.onBlur'
          :ref='formulario.field.campo.id'
        ></RF-Componente>

        <div class="checkbox" v-if="Object.keys(formulario.field.checkbox).length >= 1">
          <RF-Checkbox-Tabela
            :data-time='time'

            :cpntStatus='formulario.field.checkbox.status'
            :cpntId='formulario.field.checkbox.id' 
            :cpntNome='formulario.field.checkbox.nome'
            :cpntValue='formulario.field.checkbox.value === true ? "atualizar" : ""'
            :cpntChecked='formulario.field.checkbox.checked'
            :cpntDisabled="formulario.field.checkbox.disabled"

            :cpntOnChange='formulario.field.checkbox.onChange'
          ></RF-Checkbox-Tabela>
        </div>
      </div>

      <div class="df-reenviar-nota-botoes" v-if="Object.keys(formulario.buttons).length >= 1">
        <RF-Button v-for='(button, index) in formulario.buttons'
          :data-time='time'
          :key='index'

          :cpntStatus='button.status' 
          :cpntId='button.id' 
          :cpntTexto='button.texto' 
          :cpntClass='button.class'
          :cpntMostrar='button.mostrar'
          :cpntTabIndex='button.tabIndex'

          @onClickButton='button.onClick'
        ></RF-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.df-reenviar-nota-campos {
  margin: 10px 0px;
  background: #e9e9e9;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 25px 15px 15px 15px;
}
  .df-reenviar-nota-campos > .checkbox {
    text-align: left;
    margin: 0px;
    margin-top: 5px;
  }
.df-reenviar-nota-botoes {
  text-align: center;
  margin-top: 15px;
}
  .df-reenviar-nota-botoes > button {
    margin: 0px 5px;
  }
</style>

<style>
  .df-reenviar-nota-campos > .checkbox > .rf-web-checkbox > input + label {
    margin: 0px;
    padding-left: 0px;
  }
</style>

<script>
  export default {
    props: {
      cpntId: {
        type: Number,
        required: true
      },
      cpntTitulo: {
        type: String,
        required: false,
        default: function () {
          return 'Reenviar Nota Fiscal por e-mail'
        }
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'RF-Checkbox-Tabela': () => import('@/components/rf-geral/checkbox/RF-Checkbox-Tabela.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        formulario: {},
        contato: {}
      }
    },
    mounted: function () {
      this.reenviarNotaIniciar()
    },
    methods: {
      reenviarNotaIniciar: function () {
        var self = this

        // SETA O STATUS DA PAGINA
        self.reenviarNotaSetarStatusGeral('carregando')

        // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
        const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK

        // EXECUTA A FUNÇÃO DE CALLBACKS
        FUN_TRATAR_RETONOS_E_CALLBACK(self, {
          reenviarNotaBuscarDocumentoFiscal: [ ],
          reenviarNotaCamposIniciar: [ ],
          reenviarNotaFinalizar: [ 'reenviarNotaBuscarDocumentoFiscal', 'reenviarNotaCamposIniciar' ]
        },
        {
          reenviarNotaBuscarDocumentoFiscal: function (chave, callback, self) { self.reenviarNotaBuscarDocumentoFiscal(self, function () { callback(chave) } ) },
          reenviarNotaCamposIniciar: function (chave, callback, self) { self.reenviarNotaCamposIniciar(self, function () { callback(chave) } ) },
          reenviarNotaFinalizar: function (chave, callback, self) { self.reenviarNotaFinalizar(self, function () { callback(chave) } ) },
        })
      },
      reenviarNotaFechar: function (atualizar) {
        this.cpntFecharFormulario(atualizar, this.cpntId)
      },
      reenviarNotaSetarStatusGeral: function (status) {
        // SETA O STATUS DA PAGINA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      reenviarNotaBuscarDocumentoFiscal: function (self, callback) {
        // MONTA O QUERYGET PARA BUSCAR OS DADOS DA NOTA
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 },  where: { aAnd: [ { f: 'id', o: '=', v: self.cpntId } ] } }

        // SETA OS CAMPOS QUE DEVEM RETORNAR
        queryGet.field = { ref_cli_id: null, tpAmb: null, DocModelo: null, DocSerie: null, DocNumero: null }

        // COMUNICA COM A API
        self.$store.state.comunicaAPI('/df/get/', 'GET', queryGet, function (apiSuccess) {
          // PEGA OS DADOS RECEBIDOS DA API
          var retorno  = apiSuccess.data[0]

          // VERIFICA SE O CONTATO FOI ENCONTRADO
          switch (retorno.ref_cli_id) {
            case '':
            case null:
            case undefined:
            case '0':
              // MONTA O QUERYGET PARA BUSCAR OS DADOS DA NOTA
              var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { DocNumero: null, ref_cli_id: null },  where: { aAnd: [ { f: 'DocNumero', o: '=', v: retorno.DocNumero }, { f: 'DocSerie', o: '=', v: retorno.DocSerie }, { f: 'DocModelo', o: '=', v: retorno.DocModelo }, { f: 'tpAmb', o: '=', v: retorno.tpAmb }, { f: 'SitCodigo', o: '=', v: '100' } ] } }

              // COMUNICA COM A API
              self.$store.state.comunicaAPI('/df/get/', 'GET', queryGet, function (apiSuccess) {
                // PEGA OS DADOS RECEBIDOS DA API
                var retorno  = apiSuccess.data

                // VERIFICA SE O CONTATO FOI ENCONTRADO
                switch (retorno.ref_cli_id) {
                  case '':
                  case null:
                  case undefined:
                  case '0':
                    self.reenviarNotaSetarStatusGeral({ loc: 'WEB', cod: 500, err: 'Dados do documento fiscal não localizado.' })
                    break

                  default:
                    self.reenviarNotaBuscarContato(retorno.ref_cli_id, callback)
                    break
                }
              }, self.reenviarNotaSetarStatusGeral)
              break

            default:
              self.reenviarNotaBuscarContato(retorno.ref_cli_id, callback)
              break
          }
        }, self.reenviarNotaSetarStatusGeral)
      },
      reenviarNotaBuscarContato: function (contatoId, callback = null) {
        var self = this

        // MONTA O QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null, email: null }, where: { f: 'id', o: '=', v: contatoId } }

        // COMUNICA COM A API
        self.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, function (apiSuccess) {
          // PEGA OS DADOS DO CONTATO
          self.contato = apiSuccess.data[0]

          // EXECUTA A FUNÇÃO CALLBACK
          if (callback !== null) {
            callback()
          }
        }, self.reenviarNotaSetarStatusGeral)
      },
      reenviarNotaCamposIniciar: function (self, callback) {
        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: 'carregando',
          id: 'df-reenviar-' + self.cpntId + '--',
          field: {}
        }

        // SETA OS DADOS DA DIALOG
        self.formulario.field.campo = {
          tamanho: 1,
          id: self.formulario.id + 'campo',
          tipo: 'input',
          nome: 'E-mail',
          explica: { mensagem: 'Para enviar a nota fiscal para mais de um e-mail utilize o ponto e vírgula ";" para separar os e-mails.' },
          onChange: self.reenviarNotaCamposOnChange
        }

        // SETA O CHECKBOX
        self.formulario.field.checkbox = {
          id: self.formulario.id + 'checkbox',
          nome: '',
          value: false,
          checked: [ 'atualizar' ],
          disabled: false,
          onChange: self.reenviarNotaCamposOnChange
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CRIA OS BUTTONS
        self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario.id, [ 0 ], null, {
          env: self.reenviarNotaEnviar,
          can: self.reenviarNotaFechar
        }, function (buttons) {
          // CRIA OS BUTTONS DO FORMULARIO
          self.formulario.buttons = buttons

          // SETA O NOME CORRETO DO BUTTON
          self.formulario.buttons.env.texto = 'Reenviar'

          // LIMPA O STATUS DO FORMULARIO
          self.formulario.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          if (callback !== null) {
            callback()
          }
        })
      },
      reenviarNotaFinalizar: function (self, callback) {
        // SETA O ONCHANGE NOVAMENTE DO CAMPO
        self.formulario.field.campo.value = self.contato.email

        // VERIFICA SE TEM QUE DESATIVAR O CHECKBOX PARA CLIENTE PADRÃO
        self.formulario.field.checkbox.disabled = [ '1', '2' ].indexOf(self.contato.id) !== -1

        // SETA O NOME DO CONTATO NO CHECKBOX
        self.formulario.field.checkbox.nome = '&nbsp;Atualizar o e-mail do contato ' + self.contato.nome

        // SETA O STATUS DA PAGINA
        self.reenviarNotaSetarStatusGeral('')

        // CHAMA A FUNÇÃO PARA DAR FOCUS NO CAMPO
        self.reenviarNotaCamposFocus(self.formulario.field.campo.id)

        // EXECUTA A FUNÇÃO CALLBACK
        if (callback !== null) {
          callback()
        }
      },
      reenviarNotaCamposFocus: function (campo, tentativa = 0, self = null) {
        if (tentativa <= 10) {
          // SETA O VALOR PARA INICIAR A VARIAVEL
          if (self === null) {
            self = this
          }
  
          if ([ '', null, undefined ].indexOf(self.$refs[campo]) === -1 && Object.keys(self.$refs[campo].$refs).length >= 1 && [ '', null, undefined ].indexOf(self.$refs[campo].$refs[Object.keys(self.$refs[campo].$refs)[0]].onFocusField) === -1) {
            self.$refs[campo].$refs[Object.keys(self.$refs[campo].$refs)[0]].onFocusField()
          } else {
            setTimeout(function () { self.reenviarNotaCamposFocus(campo, (tentativa + 1), self) }, 500)
          }
        }
      },
      reenviarNotaCamposOnChange: function (value, id) {
        // PEGA O CAMPO QUE DEVE SER ATUALIZADO
        var index = id.split('--')

        // SETA O VALOR RECEBIDO
        this.formulario.field[index[1]].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index[1]].mensagem = ''
        this.formulario.field[index[1]].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      reenviarNotaEnviar: function () {
        var self = this

        // SETA O STATUS
        self.formulario.buttons.env.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { id: self.cpntId, email: self.formulario.field.campo.value, f_upd_contato: (self.formulario.field.checkbox.value === true ? 1 : 0) }

        // CONVERTE OS DADOS EM LOT
        formData = { lot: [ formData ] }

        // ENVIA O DOCUMENTO SOLICITADO POR E-MAIL
        self.$store.state.comunicaAPI('/df/enviar-link', 'POST', formData, function (apiSuccess) {
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
            // SETA O STATUS
            self.formulario.buttons.env.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // VERIFICA SE TODOS OS E-MAILS DEU E FECHA A JANELA
            if (apiSuccess.lot[0].code === '200') {
              self.reenviarNotaFechar(true)
            }
          })
        }, self.reenviarNotaSetarStatusGeral, function (apiValid, apiStatus) {
          self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, self.formulario.field, true, null)
        })
      }
    }
  }
</script>
